// Force le rechargement complet de la page lors des clics sur les liens de pagination
(function() {
  'use strict';
  
  function forcePageReload() {
    // Trouve tous les liens de pagination dans les collections
    const paginationLinks = document.querySelectorAll('a[href*="page="], .pagination a, [class*="pagination"] a');
    
    paginationLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        // Empêche le comportement par défaut (navigation AJAX)
        e.preventDefault();
        e.stopPropagation();
        
        // Force le rechargement complet de la page
        window.location.href = this.href;
      });
    });
  }
  
  // Exécuter au chargement de la page
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forcePageReload);
  } else {
    forcePageReload();
  }
  
  // Réappliquer si le DOM change (pour les thèmes qui rechargent dynamiquement la pagination)
  const observer = new MutationObserver(forcePageReload);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
})();